module.exports = "https://portperrypedals.ca/_res/img/ppstar-photo.e44d862.jpg";